/** Only paths within the local lesson-audio namespace may carry a source record. */
export function isLessonAudioPath(value:unknown):value is string {
  const prefix='/api/v1/arabic-lessons/media/audio/';
  if(typeof value!=='string'||!value.startsWith(prefix))return false;
  const parts=value.slice(prefix.length).split('/');
  return parts.length>=2&&parts.every(part=>/^[a-zA-Z0-9._-]+$/.test(part)&&part!=='.'&&part!=='..');
}
